import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components

import GenerateInstallationReport from "../../../components/SidebarMenuComponents/OAComponent/GenerateInstallationReport";
import Page from "../../../components/Page";
import IncidentTrackerListing from "../../../components/SidebarMenuComponents/OtherComponent/IncidentTrackerListing";
import SpecialEvents from "../../../components/SidebarMenuComponents/OtherComponent/SpecialEvents";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));

export default function SpecialEventEntryModule() {
    const location = useLocation();
    const accessRights = location.state;

    return (
        <Page title="Special Events | tiketic" >

            <StickyHeader title="Special Events" />

            <ContentStyle>
                <SpecialEvents />
            </ContentStyle>
        </Page>
    );
}

